import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Globals} from '../../../global-variables/globals';

@Component({
    selector: 'app-modal-confirmation-dialog',
    templateUrl: './confirmation-modal.component.html',
    styleUrls: ['./confirmation-modal.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class ConfirmationModalComponent implements OnInit {

  message: any;
  data: any;
  selfComponent: any;
  index: number;
  removalObservable: any;
  confirmation: Boolean;

  constructor(public globals: Globals) {
  }

  close() {
    console.log('close');
    this.removalObservable.next({index: this.index, data: {'confirmation': this.confirmation}, callback: this.data.callback}); // update the base modal component about the removal
    this.selfComponent.destroy();
  }

  ngOnInit() {
    console.log(this.data);
  }
}
